import Chapter from './Chapter'

export default Chapter
